import _, { find, padStart, toNumber } from "lodash";

export const householdUtil = {
  getOrderByFieldName: household => {
    const { household_id_number } = household || {};

    if (!household_id_number) return "";

    return household_id_number
      .split("-")
      .map(str => {
        const tryNumber = toNumber(str);

        if (isNaN(tryNumber)) return str;

        return padStart(str, 5, "0");
      })
      .join("");
  },
  transferHouseholdList: (householdList) => {
    const { household_users, households, building_area_numbers } = householdList;

    const building_areas = _.chain(building_area_numbers)
      .orderBy(["area_id", "area_name"])
      .uniqBy("area_id")
      .map(item => ({ id: item.area_id, name: item.area_name }))
      .value();

    // 去重複的住戶
    const users = _.chain(household_users)
      .groupBy("uuid")
      .mapValues(householdUsers => {
        // 住戶所屬的戶別
        const userHouseholdIds = _.chain(householdUsers)
          .map("household_id")
          .uniq()
          .value();
        const userHouseholdsChain = _.chain(households).filter(household =>
          userHouseholdIds.includes(household.id)
        );

        // 住戶所屬的戶別（轉換資料）
        const transferedHouseholds = userHouseholdsChain
          .map(({ id, household_id_number }) => ({ household_id: id, household_id_number }))
          .value();

        // 住戶所屬的棟號
        const buildingAreaIds = userHouseholdsChain
          .map(household => find(building_areas, { id: household.area_id })?.id)
          .compact()
          .uniq()
          .value();

        // 住戶所屬的樓層
        const floors = userHouseholdsChain
          .map("floor_at")
          .uniq()
          .value();

        return {
          user_uuid: householdUsers[0].uuid,
          username: householdUsers[0].username,
          telephone: householdUsers[0].telephone,
          is_package_protected: householdUsers[0].is_package_protected,
          floors,
          buildingAreaIds,
          households: transferedHouseholds
        };
      })
      .values()
      .value();

    // 戶別依照棟號、戶別編號排序
    const sortedHouseholds = householdUtil.sortHouseholds(households, [
      ["area_id", "_orderBy"],
      ["asc", "asc"]
    ]);


    const transferdHouseholdList = {
      ...householdList,
      building_areas,
      households: sortedHouseholds,
      users
    };

    return transferdHouseholdList;
  },
  sortHouseholds: (households, orderBy) => {
    const [orderFields, order] = orderBy || [["_orderBy"], ["asc"]];
    return _.chain(households)
      .map(household => {
        return {
          ...household,
          _orderBy: householdUtil.getOrderByFieldName(household)
        };
      })
      .orderBy(orderFields, order)
      .value();
  },
};
